export default __webpack_public_path__ + "static/media/Pytorch.a30886e6.png";